import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const ServiceDeals = () => {
  const getServiceDeals = (params = {}) => {
    return AuthAxios.get(`${DataApiUrl}/admin/service-deals`, { params }).then(res => res.data.data);
  };

  const getServiceDealById = serviceDealId => {
    return AuthAxios.get(`${DataApiUrl}/admin/service-deals/${serviceDealId}`).then(res => res.data.data);
  };

  const deleteServiceDeal = serviceDealId => {
    return AuthAxios.delete(`${DataApiUrl}/admin/service-deals/${serviceDealId}`);
  };

  const patchServiceDeal = (serviceDealId, body) => {
    return AuthAxios.patch(`${DataApiUrl}/admin/service-deals/${serviceDealId}`, body);
  };

  const postServiceDeal = body => {
    return AuthAxios.post(`${DataApiUrl}/admin/service-deals`, body);
  };

  return { getServiceDeals, deleteServiceDeal, getServiceDealById, patchServiceDeal, postServiceDeal };
};

export default ServiceDeals;
